export const GET_ALLOWANCE_LIST_SUCCESS = "GET_ALLOWANCE_LIST_SUCCESS";
export const GET_ALLOWANCE_PRESENCE_TICKET_MEETING_LIST_SUCCESS = "GET_ALLOWANCE_PRESENCE_TICKET_MEETING_LIST_SUCCESS";